import { render, staticRenderFns } from "./VideosForm.vue?vue&type=template&id=777b9b43&scoped=true&"
import script from "./VideosForm.vue?vue&type=script&lang=ts&"
export * from "./VideosForm.vue?vue&type=script&lang=ts&"
import style0 from "./VideosForm.vue?vue&type=style&index=0&id=777b9b43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777b9b43",
  null
  
)

export default component.exports